import { Box as NovaBox, BoxProps as NovaBoxProps } from '@fme-nova/components'
import { BoxProps as MuiBoxProps, default as MuiBox } from '@mui/material/Box'

import { createComponentWrapperWithRef } from '../../theme'

export const Box = createComponentWrapperWithRef<MuiBoxProps | NovaBoxProps>(
  {
    mui: MuiBox,
    nova: NovaBox,
  },
  'Box',
)
